import Button from "@pathwright/ui/src/components/button/Button"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import TagSelector from "@pathwright/ui/src/components/tag/selector/TagSelector"
import { media } from "@pathwright/ui/src/components/utils/styles"
import { useState } from "react"
import styled from "styled-components"
import { useDiscussionListContext } from "../../../discussion/list/DiscussionListContainer"
import useTags from "../../../tag/useTags"
import CommunityDiscussionFilter from "./CommunityDiscussionFilter"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.max.phone`
    flex-direction: column;
  `}

  .CommunityAreaFilter {
    flex-grow: 0;
  }

  .TagSelector {
    margin-right: 4px;
  }

  .Button.primary-alt,
  .Button.primary-alt {
    padding: 0.6em !important;
  }

  /* Toggling the CommunityAreaFilters when on mobile */
  ${(p) =>
    !p.mobileNavExpanded &&
    media.max.phone`
    .CommunityAreaFilter {
      display: none;
    }
  `}
`

const TagSelectorRow = styled.div`
  display: flex;
  align-items: center;

  /* Ugh, hardcoding expand button to be same size as TagSelector on mobile */
  & > .Button {
    height: 40px;
    width: 40px;
  }

  ${media.max.phone`
    margin-bottom: .4em;
`}

  ${media.min.phone`
    & > .Button {
      display: none;
    }
`}
`

const CommunityDiscussionTagFilter = () => {
  const { t } = useTranslate()
  const {
    context,
    tags: selectedTags,
    onFilterTags
  } = useDiscussionListContext()

  const { tags } = useTags({
    context,
    selectedTags
  })

  // Don't show the filter if there are no tags to filter discussions by.
  // Simply providing basic TagSelector as creating a tag does not make sense
  // in this context, managing tags doesn't quite make sense either.
  return tags.filtered.length ? (
    <TagSelector
      tags={tags}
      onChange={onFilterTags}
      inverted
      styles={{
        container: {
          minWidth: "160px",
          maxWidth: "200px",
          borderRadius: "100px"
        },
        control: {
          borderRadius: "100px"
        },
        placeholder: {
          fontWeight: "bold"
        }
      }}
      selectLabel={t("Filter by topic")}
    />
  ) : null
}

const CommunityDiscussionNav = ({ inverted }) => {
  // Handles toggle state for showing/hiding the CommunityDiscussionFilter when on mobile.
  const [mobileNavExpanded, setMobileNavExpanded] = useState(false)

  return (
    <Container mobileNavExpanded={mobileNavExpanded}>
      <TagSelectorRow>
        <CommunityDiscussionTagFilter />
        <Button
          styleType="primary-alt"
          icon="ellipses-horizontal"
          onClick={() => setMobileNavExpanded(!mobileNavExpanded)}
        />
      </TagSelectorRow>
      <CommunityDiscussionFilter inverted={inverted} />
    </Container>
  )
}

CommunityDiscussionNav.displayName = "CommunityDiscussionNav"

export default CommunityDiscussionNav
